"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarGraph = exports.BarGraphCollection = exports.BAR_GAP = exports.DEFAULT_SINGLE_BAR_WIDTH = exports.BAR_GRAPH_HEIGHT = void 0;
var react_1 = __importStar(require("react"));
var __1 = require("../../../..");
var __2 = require("../../../..");
var styled_1 = require("./styled");
var useGetDimensions_1 = require("./utils/useGetDimensions");
// import { __GetContentTypeConfigNew } from "../../../../../utils/getters/gettersV2";
var CustomTooltip_1 = __importDefault(require("../BarChart/comps/CustomTooltip"));
var usePrepareData_1 = require("./utils/usePrepareData");
var grey5 = __1.colors2.grey5;
exports.BAR_GRAPH_HEIGHT = 250;
exports.DEFAULT_SINGLE_BAR_WIDTH = 24;
exports.BAR_GAP = 0.3;
var BarGraphCollection = function (_a) {
    var originalData = _a.data, valuePath = _a.valuePath, _b = _a.labelPath, labelPath = _b === void 0 ? "display" : _b, _c = _a.tooltipLabelsMapping, tooltipLabelsMapping = _c === void 0 ? {} : _c, onClick = _a.onClick, _d = _a.showCount, showCount = _d === void 0 ? true : _d, _e = _a.showPercent, showPercent = _e === void 0 ? true : _e, groupBy = _a.groupBy, totalDataCount = _a.totalDataCount, debug = _a.debug
    // tooltipLabelsPath,
    // colorIdx = 0,
    // summarizeAfterIdx = 5,
    // breakdownDisplayType = "grouped"
    ;
    var containerRef = (0, react_1.useRef)();
    var _f = (0, react_1.useState)(0), containerWidth = _f[0], setContainerWidth = _f[1];
    var highestCount = originalData === null || originalData === void 0 ? void 0 : originalData.reduce(function (highest, item) { return item.value > highest ? item.value : highest; }, 0);
    var transformedData = (0, react_1.useMemo)(function () {
        return (0, usePrepareData_1.usePrepareData)({ data: originalData, valuePath: valuePath, labelPath: labelPath, tooltipLabelsMapping: tooltipLabelsMapping, groupBy: groupBy });
    }, [originalData, valuePath, labelPath, tooltipLabelsMapping, groupBy]);
    var data = (0, useGetDimensions_1.useGetDimensions)(transformedData, exports.BAR_GRAPH_HEIGHT, containerWidth, totalDataCount, highestCount);
    (0, react_1.useEffect)(function () {
        var handleResize = function () {
            var _a, _b;
            setContainerWidth((_b = (_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.width);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function () { return window.removeEventListener("resize", handleResize); };
    }, [transformedData]);
    if ((data === null || data === void 0 ? void 0 : data.length) === 0) {
        return null;
    }
    var barDivisions = (0, useGetDimensions_1.divideBarIntoEqualParts)(highestCount);
    return (react_1.default.createElement(styled_1.StyledBarGraphContainer, { style: { width: "auto" }, ref: containerRef },
        react_1.default.createElement("div", { style: { position: "absolute", left: 50, height: "".concat(exports.BAR_GRAPH_HEIGHT, "px"), width: "20px" } },
            react_1.default.createElement(styled_1.YAxisLabels, null, (0, styled_1.generateYAxisValues)(barDivisions).map(function (value, index) { return (react_1.default.createElement(__2.UI_BODY_SM, { key: index }, String(value))); }))),
        react_1.default.createElement(styled_1.StyledBarGraphCollectionWrapper, { style: {
                width: "auto",
                gap: "".concat(exports.BAR_GAP, "rem"),
                overflowX: "auto"
            } }, data === null || data === void 0 ? void 0 : data.map(function (tagCategory, index1) {
            var categoryTitle = (tagCategory === null || tagCategory === void 0 ? void 0 : tagCategory.tagCategory) ? (tagCategory.tagCategory.charAt(0).toUpperCase() + tagCategory.tagCategory.slice(1)) : undefined;
            //  __GetContentTypeConfigNew(tagCategory.tagCategory)?.general?.content?.title || 
            return (react_1.default.createElement("div", { key: "".concat(index1, "-").concat(tagCategory.tagCategory), style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "".concat(exports.BAR_GAP, "rem"),
                    height: "".concat(exports.BAR_GRAPH_HEIGHT + 50, "px"),
                    marginBottom: "0.6rem"
                } },
                react_1.default.createElement(exports.BarGraph, { tagCategory: tagCategory, index1: index1, showCount: showCount, showPercent: showPercent, onClick: onClick, debug: debug, highestCount: highestCount }),
                categoryTitle && react_1.default.createElement("div", { title: categoryTitle, style: {
                        width: "".concat(tagCategory === null || tagCategory === void 0 ? void 0 : tagCategory.width, "px"),
                        background: grey5,
                        borderRadius: "2px",
                        padding: "0.8rem",
                        maxHeight: "50px",
                        overflow: "hidden"
                    } },
                    react_1.default.createElement(__2.UI_BODY_SEMIBOLD_SM, null,
                        react_1.default.createElement("p", { style: {
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "100%"
                            } }, categoryTitle)))));
        }))));
};
exports.BarGraphCollection = BarGraphCollection;
var BarGraph = function (_a) {
    var _b;
    var tagCategory = _a.tagCategory, index1 = _a.index1, _c = _a.showCount, showCount = _c === void 0 ? true : _c, _d = _a.showPercent, showPercent = _d === void 0 ? true : _d, onClick = _a.onClick, debug = _a.debug;
    var _e = (0, react_1.useState)({ x: 0, y: 0 }), mousePosition = _e[0], setMousePosition = _e[1];
    var _f = (0, react_1.useState)(null), activeTooltip = _f[0], setActiveTooltip = _f[1];
    (0, react_1.useEffect)(function () {
        var handleMouseMove = function (e) {
            setMousePosition({ x: e.clientX, y: e.clientY });
        };
        window.addEventListener('mousemove', handleMouseMove);
        return function () {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);
    var truncateText = function (text, maxLength) {
        if (maxLength === void 0) { maxLength = 30; }
        if (!text)
            return '';
        if (text.length <= maxLength)
            return text;
        return text.slice(0, maxLength) + '...';
    };
    var handleBarMouseEnter = function (index) {
        setActiveTooltip(index);
    };
    var handleBarMouseLeave = function () {
        setActiveTooltip(null);
    };
    var handleBarClick = function (tag) {
        if (onClick) {
            onClick(tag.display);
        }
    };
    return (react_1.default.createElement(styled_1.StyledBarGraphWrapper, { style: {
            height: "".concat(exports.BAR_GRAPH_HEIGHT, "px"),
            gap: "".concat(exports.BAR_GAP, "rem"),
        } }, (_b = tagCategory === null || tagCategory === void 0 ? void 0 : tagCategory.tagSpecificCount) === null || _b === void 0 ? void 0 : _b.map(function (tag, index) {
        var tooltipData = [{
                percentage: showPercent ? tag.percentage : undefined,
                count: showCount ? tag.count : undefined,
                tooltipLabel: tag.display
            }];
        return (react_1.default.createElement("div", { key: tag._id || "".concat(index1, "-").concat(index), onMouseEnter: function () { return handleBarMouseEnter(index); }, onMouseLeave: handleBarMouseLeave, onClick: function () { return handleBarClick(tag); }, style: { cursor: onClick ? 'pointer' : 'default' } },
            react_1.default.createElement(styled_1.StyledSingleBarWrapper, { barSections: tag.barSections, debug: debug },
                react_1.default.createElement(styled_1.StyledBar, { style: {
                        height: "".concat(tag.height, "px"),
                        width: "".concat(tag.width, "px")
                    } }),
                react_1.default.createElement(styled_1.StyledLabelWrapper, null,
                    react_1.default.createElement(__2.UI_BODY_SM, null, truncateText(tag === null || tag === void 0 ? void 0 : tag.display, 30))),
                activeTooltip === index && (react_1.default.createElement(CustomTooltip_1.default, { active: true, payload: [tag], mousePosition: mousePosition, value: tooltipData, showPercent: showPercent })))));
    })));
};
exports.BarGraph = BarGraph;
